export default __webpack_public_path__ + "static/media/epi5VidM.1fbc5c81.jpg";